import { PropsWithChildren, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Container } from './Container';
import { Paragraph, Title } from './Text';

const Background = styled(Box)`
	flex-grow: 0;
	flex-shrink: 0;
`;

export function Jumbo(
	props: PropsWithChildren<{
		title?: string;
		alternativePageTitle?: string;
		description?: string;
		header?: ReactNode;
		button?: ReactNode;
		footer?: ReactNode;
		alignItems?: 'center' | 'flex-start';
		wide?: number | boolean;
	}>,
) {
	return (
		<>
			<Helmet>
				<title>{props.alternativePageTitle ?? props.title}</title>
			</Helmet>
			<Background>
				<Container wide={props.wide}>
					<Box py={4}>
						{props.header && <Box mb={3}>{props.header}</Box>}
						<Flex flexDirection={['column', 'column', 'row']} alignItems={props.alignItems}>
							<Box maxWidth={props.children ? undefined : 640} flexGrow={1} flexShrink={1}>
								{props.title ? <Title>{props.title}</Title> : <Title.Skeleton />}
								{props.description && <Paragraph mt={3}>{props.description}</Paragraph>}
								{props.children}
							</Box>
							{props.button && (
								<>
									<Box flexGrow={1} flexShrink={1} />
									<Box ml={[0, 0, 2]} mt={[3, 3, 0]} flexGrow={0} flexShrink={0}>
										{props.button}
									</Box>
								</>
							)}
						</Flex>
					</Box>
				</Container>
			</Background>
			{props.footer}
		</>
	);
}

export function JumboSkeleton(props: { wide?: number | boolean; children?: ReactNode }) {
	return (
		<Background>
			<Container wide={props.wide}>
				<Box maxWidth={640} flexGrow={1} flexShrink={1} py={4}>
					<Title.Skeleton />
					{props.children}
				</Box>
			</Container>
		</Background>
	);
}

Jumbo.Skeleton = JumboSkeleton;
